import { LengthUnits } from "@/libs/units/length";
import type { RenderScenarioExportCols } from "./sizingExportTypes";
import { PercentageUnits } from "@/libs/units/percentage";

export const renderMleCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "MLE",
    label: "MLE Description",
    targetUnit: null,
    value: calcs.motorLeadExtensionCalculations.mleCableData.value.cableHeader
  },
  {
    section: "MLE",
    label: "MLE Dimensions",
    targetUnit: LengthUnits.Inches,
    value:
      scenario.scenario.value?.equipment?.r_mle &&
      `${scenario.scenario.value?.equipment?.r_mle?.width_inches}W -
      ${scenario.scenario.value?.equipment?.r_mle?.depth_inches}D`,
    disableConversion: true
  },
  {
    section: "MLE",
    label: "MLE Length",
    targetUnit: targetUnits.largeLengthUnit,
    value: scenario.scenario.value?.equipment?.r_mle?.length_feet
  },
  {
    section: "MLE",
    label: "MLE Weight",
    targetUnit: targetUnits.massUnit,
    value: calcs.equipmentWeights.mleWeightLbs
  },
  {
    section: "MLE",
    label: "MLE Temperature Rating",
    targetUnit: targetUnits.tempUnit,
    value: scenario.scenario.value?.equipment?.r_mle?.max_temperature_fahrenheit
  },
  {
    section: "MLE",
    label: "MLE Operating Temp",
    targetUnit: targetUnits.tempUnit,
    value:
      calcs.motorLeadExtensionCalculations?.mleCableData?.value
        .cableMaxTemperatureF
  },
  {
    section: "MLE",
    label: "MLE Motor Load",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      calcs.motorLeadExtensionCalculations?.mleCableData?.value
        .cableMotorLoadRatio
    )
  },
  {
    section: "MLE",
    label: calcs.isScenarioEspShore.value
      ? "MLE Max Amps at Operating Temperature"
      : "MLE Max Amps at Duty Point Temperature",
    targetUnit: targetUnits.currentUnit,
    value:
      calcs.motorLeadExtensionCalculations?.mleCableData?.value
        .maxAmpsAtMaxTemperatureA
  },
  {
    section: "MLE",
    label: "MLE Max Pothead Temperature",
    targetUnit: targetUnits.tempUnit,
    value:
      scenario.scenario.value?.equipment?.r_mle
        ?.max_pothead_temperature_fahrenheit
  }
];
